import { PageRequest } from '@/core/request/PageRequest';
import { ManifestNotesType } from '../../invoiceTransmissionHub/AuxiliaryDocuments/AuxiliaryDocuments.types';

export enum RecipientInvoiceSituation {
  pending = 'PENDING',
  confirmedOperation = 'CONFIRMED_OPERATION',
  confirmed = 'CONFIRMED',
  unknown = 'UNKNOWN',
  notExecuted = 'NOT_EXECUTED',
  noSituation = 'NO_SITUATION',
}

export const RecipientInvoiceSituationLabel = {
  [RecipientInvoiceSituation.pending]: 'Pendente',
  [RecipientInvoiceSituation.confirmedOperation]: 'Confirmação da operação',
  [RecipientInvoiceSituation.confirmed]: 'Ciência da Emissão',
  [RecipientInvoiceSituation.unknown]: 'Desconhecimento da Operação',
  [RecipientInvoiceSituation.notExecuted]: 'Operação não Realizada',
  [RecipientInvoiceSituation.noSituation]: 'Sem situação',
};

export interface ManifestationRecipientInvoice {
  id: number;
  companyId: number;
  situation: RecipientInvoiceSituation;
  nsu: string;
  nfeKey: string;
  issuer: string;
  eventDateTime: string;
  value: number;
  protocol: string;
  filePath: string;
  reason: string;
  manifestType: ManifestNotesType;
}

export interface RecipientInvoiceFormValues {
  companyId: number;
  situation: RecipientInvoiceSituation;
  nsu: string;
  nfeKey: string;
  issuer: string;
}

export interface RecipientInvoiceQueryFilter extends PageRequest {
  companyId?: number;
  situation?: RecipientInvoiceSituation;
  nsu?: string;
  nfeKey?: string;
  issuer?: string;
}

export interface IntendedManifestRequest {
  invoiceId: number;
  operation?: number;
  justification?: string;
}

export interface RecipientInvoiceMaximumNsuQueryFilter {
  companyId: number;
}
